module.exports = __webpack_public_path__ + "img/initerviewprocess.fc851d7b.svg";